// 

// app/store.js
import { configureStore, combineReducers } from '@reduxjs/toolkit';

// Reducers
import authReducer from '../Auth/Hooks/authSlice.jsx';
import policyReducer from './authPolicy';
import claimReducer from '../HeadOffice/Hooks/ReportClaim/claimReportDetailSlice.jsx';
import policyDetailReducer from '../BranchOffice/Hooks/authPolicyDetail';
import statusPolicyReducer from './authStatusPolicy';
import statusPolicyDetailReducer from './authStatusPolicyDetail';
import profileReducer from './authProfile';
import allClaimReducer from '../HeadOffice/Hooks/ReportClaim/claimReportListSlice.jsx';
import claimCommentSlice from '../BranchOffice/Hooks/authCommentAdmin.jsx';
// import claimReportBranchReducer from "../BranchOffice/Hooks/claimReportDetailBranchSlice"; 
import claimDetailReducer from '../BranchOffice/Hooks/claimReportDetailBranchSlice';
import allClaimBranchReducer from '../BranchOffice/Hooks/claimReportList.jsx';
// import listDocReducer from '../BranchOffice/Hooks/useListDoc.jsx';
// import listAnswerDocReducer from '../BranchOffice/Hooks/useListAnswerDoc.jsx';

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  policy: policyReducer,
  claims: claimReducer,
  policyDetail: policyDetailReducer,
  statusPolicy: statusPolicyReducer,
  statusPolicyDetail: statusPolicyDetailReducer,
  profile: profileReducer,
  allClaim: allClaimReducer,
  allClaimBranch: allClaimBranchReducer, 
  postComment: claimCommentSlice,
  // listDoc: listDocReducer,
  // listAnswerDoc: listAnswerDocReducer,
  // claim: claimReportBranchReducer,
  claimDetail: claimDetailReducer
});

// Buat store dengan persistedReducer
export const store = configureStore({
  reducer: rootReducer,
});
